
export const exampleRouteScriptFunctions = {
	_project: {
		name: "Function Examples",
		authors: ["iTNTPiston"],
		url: "https://celer.itntpiston.app/#/docs/functions",
		version: "1.0.0",
		description: "Examples of functions"
	},
	_route: [
		{
			"Example Functions":[
				".link(https://youtu.be/ZYAnULQZyiw?t=73)",
				".link([Sor Clip]https://youtu.be/ZYAnULQZyiw?t=73)",
				"_Korok::R61",
				"_Korok::N59",

			],
		},

	]};
